@if (
  {
    isIdentifyingCompany: isIdentifyingCompany$ | async,
    violations: violations$ | async
  };
  as STATE
) {
  <main class="company-identification-form">
    <hgroup class="company-identification-form__header">
      <h2>Identification fiscale (NCC + NTD)</h2>
      <p>Vérifiez l’existence de votre entreprise.</p>
    </hgroup>

    <form class="form" [formGroup]="form">
      <div class="form__group">
        <label for="ncc" class="form__label"
          >NCC (Numéro de Compte Contribuable)
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-profile" color="primary"></mat-icon>
          </span>
          <input
            type="text"
            id="ncc"
            formControlName="ncc"
            class="form__input"
            placeholder="Ex. 0123456A"
          />
        </div>
        @if (ncc?.touched && ncc?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          >
          </mat-error>
        }
        @if (ncc?.getError('httpError'); as httpError) {
          <mat-error [innerHtml]="httpError" class="form__error-red">
          </mat-error>
        }
      </div>

      <div class="form__group">
        <label for="ntd" class="form__label"
          >NTD (Numéro de Télédéclarant)
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-profile" color="primary"></mat-icon>
          </span>
          <input
            type="text"
            id="ntd"
            formControlName="ntd"
            class="form__input"
            placeholder="Ex. 12345678923432"
          />
        </div>
        @if (ntd?.touched && ntd?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          >
          </mat-error>
        }
        @if (ntd?.getError('httpError'); as httpError) {
          <mat-error [innerHtml]="httpError" class="form__error-red">
          </mat-error>
        }
      </div>

      <div class="form__actions">
        <button
          button
          [loading]="!!STATE.isIdentifyingCompany"
          [disabled]="form.invalid || !!STATE.isIdentifyingCompany"
          (click)="identifyCompany()"
          size="lg"
          [fullWidth]="true"
          loadingText="Vérification en cours..."
        >
          Vérifier mon identité
        </button>

        <p class="form__actions--text">
          Vous avez déjà un compte ?
          <span>
            <a [routerLink]="routes.login" class="form__actions--link"
              >Se connecter</a
            >
          </span>
        </p>
      </div>
    </form>
  </main>
}
